import debounce from '@zcorky/debounce';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { color, easeOut, media, sans } from './layouts/config';

interface Props {
  content: string;
}

interface State {
  offset: number;
}

export class Description extends React.PureComponent<Props, State> {
  title: HTMLSpanElement | null = null;
  state = { offset: 0 };

  constructor(props: Props) {
    super(props);
  }

  calculateOffset = () => {
    const img = document.getElementsByClassName('heroImage')[0];

    if (!this.title || !img) {
      return;
    }

    const titleD = this.title.offsetHeight;
    const titleDD = this.title.getBoundingClientRect().bottom;
    const imgD = img.getBoundingClientRect();

    this.setState({
      offset: titleDD - titleD / 4 - imgD.top + 24
    });
  };

  calculateOffsetD = debounce(this.calculateOffset, 200);

  componentDidMount() {
    window.setTimeout(this.calculateOffset, 200);
    window.addEventListener('resize', this.calculateOffsetD);

    // @ts-ignore
    this.title = document.getElementsByClassName('heroTitle')[0];
    if (this.title) {
      this.title.addEventListener('transitionend', this.calculateOffsetD);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateOffsetD);
    if (this.title) {
      this.title.removeEventListener('transitionend', this.calculateOffsetD);
    }
  }

  render() {
    return (
      <Div
        offset={this.state.offset}
        dangerouslySetInnerHTML={{
          __html: this.props.content
        }}
      />
    );
  }
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    transform: 1;
  }
`;

export const Div = styled.div<{ offset: number }>`
  transition: top ${easeOut};

  p {
    font-family: ${sans};
    margin: 1em auto;

    .gatsby-resp-image-wrapper {
      border: 1px solid ${color.notelight};
      box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.08);
      margin-left: 1rem;
      margin-right: 1rem;
      overflow: hidden;
      width: auto;
    }

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
    }
  }

  a {
    color: inherit;
    transition: all ${easeOut};
    text-decoration: none;
    background: linear-gradient(
      to right,
      ${color.accent} 0%,
      ${color.accentD} 100%
    );
    background-size: 100% 1px;
    background-repeat: repeat-x;
    background-position: 0 calc(1em + 2px);

    &:hover {
      text-decoration: none;
      background: linear-gradient(
        to right,
        ${color.brand} 0%,
        ${color.brandD} 100%
      );
      background-size: 100% 1px;
      background-repeat: repeat-x;
      background-position: 0 calc(1em + 4px);
    }
  }

  ${media.lg`
    width: 25%;
    position: absolute;
    right: 0;
    top: ${({ offset }: State) => (offset > 0 ? `${offset}px` : '75%')};
    animation: ${fadeIn} 750ms ease-out;
    padding-left: 2rem;

    p {
      margin-bottom: 0;
      margin-top: 0;
    }
  `};

  ${media.xl`
    padding-left: 3.5rem;
  `};
`;
